<template>
  <div class="income-plan-detail">
    <a-spin :spinning="loading">
      <div class="content flex-ct between" style="min-height: 0">
        <a-tabs default-active-key="BaseInfo" @change="changeTabs">
          <a-tab-pane key="BaseInfo" :tab="$t('基本信息')"></a-tab-pane>
          <a-tab-pane key="DetailInfo" :tab="$t('明细信息')"></a-tab-pane>
          <a-tab-pane key="AllocationInfo" :tab="$t('分摊明细')" v-if="isDetail"></a-tab-pane>
        </a-tabs>
        <div class="flex-ct gap10" v-show="!loading">
          <OperateBtn
            v-if="formData.status === 'DRAFT' && isDetail && !isEdit"
            api="operateIncomePlan"
            :text="$t('提交')"
            :params="{ id: id, operateType: operateType.SUBMIT }"
            @success="init"
          />
          <OperateBtn
            v-if="formData.status === 'WAIT_CHECK' && isDetail && !isEdit"
            api="operateIncomePlan"
            :text="$t('审核')"
            :params="{ id: id, operateType: operateType.CHECK }"
            @success="init"
          />
          <OperateBtn
            v-if="['DRAFT', 'WAIT_CHECK'].includes(formData.status) && isDetail && !isEdit"
            api="operateIncomePlan"
            type="danger"
            :text="$t('作废')"
            :params="{ id: id, operateType: operateType.CANCEL }"
            @success="init"
          />
          <!-- <FindRelatedDocBtn :id="id" :docType="docType" v-if="isDetail" /> -->
          <IncomePlanPushBtn
            v-if="isDetail"
            :pushList="[{ planId: id, allocationIdList: selectedAllocationKeys }]"
            :disabled="selectedAllocationKeys.length === 0"
            @success="init"
          />
        </div>
      </div>

      <div class="content-overflow">
        <section class="left-div fixContent" :style="{ height: scrollHeight }">
          <a-form-model ref="ruleForm" :model="formData" :rules="rules">
            <ModalBox id="BaseInfo" :title="$t('基本信息')">
              <a-row :gutter="16">
                <a-col :span="6" v-if="isDetail">
                  <a-form-model-item :label="$t('计划编号')">
                    <a-input disabled v-model="formData.planSn" />
                  </a-form-model-item>
                </a-col>
                <a-col :span="6" v-if="isDetail">
                  <a-form-model-item :label="$t('状态')">
                    <a-input disabled :value="incomePlanStatusMapping[formData.status]" />
                  </a-form-model-item>
                </a-col>
                <a-col :span="6">
                  <a-form-model-item :label="$t('结算组织')" prop="businessUnitCode">
                    <a-input v-if="isDisabled" disabled v-model="formData.businessUnitName" />
                    <CommonSelect
                      v-else
                      :isBu="true"
                      :list="$store.state.settlementBuList"
                      :placeholder="$t('请选择结算组织')"
                      :code.sync="formData.businessUnitCode"
                      @change="(item) => (formData.businessUnitName = item?.name)"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="6">
                  <a-form-model-item :label="$t('计划类型')" prop="planType">
                    <a-input
                      v-if="isDisabled"
                      disabled
                      :value="mappings.planType[formData.planType] || formData.planType"
                    />
                    <a-select
                      v-else
                      allow-clear
                      v-model="formData.planType"
                      :placeholder="$t('请选择计划类型')"
                      style="width: 100%"
                    >
                      <a-select-option
                        v-for="(value, key) in mappings.planType"
                        :key="key"
                        :value="key"
                      >
                        {{ value }}
                      </a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
                <a-col :span="6">
                  <a-form-model-item :label="$t('分摊方式')">
                    <a-input
                      v-if="isDisabled"
                      disabled
                      :value="mappings.allocationMethod[formData.allocationMethod] || ''"
                    />
                    <a-select
                      v-else
                      allow-clear
                      v-model="formData.allocationMethod"
                      :placeholder="$t('请选择分摊方式')"
                      style="width: 100%"
                    >
                      <a-select-option
                        v-for="(value, key) in mappings.allocationMethod"
                        :key="key"
                        :value="key"
                      >
                        {{ value }}
                      </a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
                <a-col :span="6">
                  <a-form-model-item :label="$t('业务单据类型')">
                    <a-input
                      disabled
                      :value="mappings.bizDocType[formData.bizDocType] || formData.bizDocType"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="6">
                  <a-form-model-item :label="$t('业务单据编号')">
                    <a-input disabled v-model="formData.bizDocSn" />
                  </a-form-model-item>
                </a-col>
                <a-col :span="6">
                  <a-form-model-item :label="$t('开始日期')">
                    <DatePicker
                      v-if="!isDisabled"
                      :needhms="false"
                      style="background-color: #ffffff; width: 100%"
                      :init-date-time="formData.startDate"
                      @choose="(d) => (formData.startDate = d.data)"
                      :placehold="$t('开始日期')"
                    />
                    <a-input
                      v-else
                      disabled
                      :value="
                        formData.startDate ? dayjs(formData.startDate).format('YYYY-MM-DD') : ''
                      "
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="6">
                  <a-form-model-item :label="$t('结束日期')">
                    <DatePicker
                      v-if="!isDisabled"
                      :needhms="false"
                      style="background-color: #ffffff; width: 100%"
                      :init-date-time="formData.endDate"
                      @choose="(d) => (formData.endDate = d.data)"
                      :placehold="$t('结束日期')"
                    />
                    <a-input
                      v-else
                      disabled
                      :value="formData.endDate ? dayjs(formData.endDate).format('YYYY-MM-DD') : ''"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="6">
                  <a-form-model-item :label="$t('结算货币')">
                    <a-input v-if="isDisabled" disabled v-model="formData.settlementCurrency" />
                    <SelectCurrency
                      v-else
                      :code.sync="formData.settlementCurrency"
                      style="width: 100%"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="6">
                  <a-form-model-item :label="$t('本位币')">
                    <a-input v-if="isDisabled" disabled v-model="formData.functionalCurrency" />
                    <SelectCurrency
                      v-else
                      :code.sync="formData.functionalCurrency"
                      style="width: 100%"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="6">
                  <a-form-model-item :label="$t('总金额')">
                    <PriceInput
                      :value="formData.totalAmount"
                      :currency="formData.settlementCurrency"
                      :showTxt="true"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="6">
                  <a-form-model-item :label="$t('未税金额')">
                    <PriceInput
                      :value="formData.totalAmountWithoutTax"
                      :currency="formData.settlementCurrency"
                      :showTxt="true"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="6">
                  <a-form-model-item :label="$t('税额')">
                    <PriceInput
                      :value="formData.taxAmount"
                      :currency="formData.settlementCurrency"
                      :showTxt="true"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="6">
                  <a-form-model-item :label="$t('总成本')">
                    <PriceInput
                      :value="formData.totalCost"
                      :currency="formData.settlementCurrency"
                      :showTxt="true"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="6">
                  <a-form-model-item :label="$t('备注')">
                    <a-input
                      v-model="formData.remark"
                      :disabled="isDisabled"
                      :placeholder="$t('备注')"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="6" v-if="isDetail">
                  <a-form-model-item :label="$t('已确认金额')">
                    <PriceInput
                      :value="formData.confirmedAmount"
                      :currency="formData.settlementCurrency"
                      :showTxt="true"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="6" v-if="isDetail">
                  <a-form-model-item :label="$t('已确认成本')">
                    <PriceInput
                      :value="formData.confirmedCost"
                      :currency="formData.settlementCurrency"
                      :showTxt="true"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="6" v-if="isDetail">
                  <a-form-model-item :label="$t('创建时间')">
                    <a-input disabled v-model="formData.createdAt" />
                  </a-form-model-item>
                </a-col>
                <a-col :span="6" v-if="isDetail">
                  <a-form-model-item :label="$t('创建人')">
                    <a-input disabled v-model="formData.createdUser" />
                  </a-form-model-item>
                </a-col>
                <a-col :span="6" v-if="isDetail">
                  <a-form-model-item :label="$t('更新时间')">
                    <a-input disabled v-model="formData.updatedAt" />
                  </a-form-model-item>
                </a-col>
                <a-col :span="6" v-if="isDetail">
                  <a-form-model-item :label="$t('更新人')">
                    <a-input disabled v-model="formData.updatedUser" />
                  </a-form-model-item>
                </a-col>
              </a-row>
            </ModalBox>
          </a-form-model>

          <ModalBox id="DetailInfo" :title="$t('明细信息')">
            <!-- 添加商品工具栏（仅在创建或编辑模式下展示） -->
            <div class="flex-ct mb12" v-if="!isDisabled">
              <SkuQuickQueryModal style="width: 320px" @selected="handleChangeSku" />
              <a-button type="primary" style="margin-left: 15px" @click="addGoodsToTable">
                <i class="icon iconfont icon-new" style="margin-right: 5px"></i>
                {{ $t('添加') }}
              </a-button>
              <a-button style="margin-left: 10px" @click="handleAddBlankLine">
                <a-icon type="plus" />
                {{ $t('添加自定义行') }}
              </a-button>
            </div>

            <a-table
              :columns="detailColumns"
              :dataSource="formData.detailList || []"
              bordered
              size="middle"
              :pagination="false"
              :scroll="{ x: 2400 }"
              :rowKey="(record, index) => index"
            >
              <!-- 商品信息 -->
              <template slot="itemInfo" slot-scope="text, record">
                <div v-if="record.itemName || record.gtin">
                  <div v-if="record.itemName">{{ $t('名称') }}: {{ record.itemName }}</div>
                  <div v-if="record.gtin">{{ $t('代码') }}: {{ record.gtin }}</div>
                </div>
                <div v-else-if="!isDisabled">
                  <a-input
                    v-model="record.itemName"
                    size="small"
                    :placeholder="$t('商品名称')"
                    style="margin-bottom: 4px"
                  />
                  <a-input v-model="record.gtin" size="small" :placeholder="$t('商品代码')" />
                </div>
              </template>

              <!-- 商品类型 -->
              <template slot="itemType" slot-scope="text, record">
                <a-select
                  v-if="!isDisabled"
                  v-model="record.itemType"
                  allow-clear
                  size="small"
                  style="width: 100%"
                >
                  <a-select-option
                    v-for="item in goodsTypeOptions"
                    :key="item.code"
                    :value="item.code"
                  >
                    {{ item.name }}
                  </a-select-option>
                </a-select>
                <span v-else>{{ goodsTypeMapping[text] || text }}</span>
              </template>

              <!-- 商品数量 -->
              <template slot="quantity" slot-scope="text, record">
                <div v-if="!isDisabled" class="flex-ct">
                  <a-input-number
                    v-model="record.quantity"
                    size="small"
                    :min="0"
                    style="width: 80px"
                    @change="(val) => (record.rawQuantity = val)"
                  />
                  <span style="margin-left: 4px">
                    {{ record.rawUnit || record.baseUnit || '' }}
                  </span>
                </div>
                <span v-else>{{ text }} {{ record.rawUnit || record.baseUnit || '' }}</span>
              </template>

              <!-- 含税金额 -->
              <template slot="plannedAmount" slot-scope="text, record">
                <PriceInput
                  v-if="!isDisabled"
                  :value.sync="record.plannedAmount"
                  :currency="formData.settlementCurrency"
                  @blur="onAmountChange(record)"
                />
                <PriceInput
                  v-else
                  :value="text"
                  :showTxt="true"
                  :currency="formData.settlementCurrency"
                />
              </template>

              <!-- 未税金额 -->
              <template slot="plannedAmountWithoutTax" slot-scope="text, record">
                <PriceInput
                  v-if="!isDisabled"
                  :value.sync="record.plannedAmountWithoutTax"
                  :currency="formData.settlementCurrency"
                  @blur="onWithoutTaxChange(record)"
                />
                <PriceInput
                  v-else
                  :value="text"
                  :showTxt="true"
                  :currency="formData.settlementCurrency"
                />
              </template>

              <!-- 税额 -->
              <template slot="plannedTaxAmount" slot-scope="text, record">
                <PriceInput
                  v-if="!isDisabled"
                  :value.sync="record.plannedTaxAmount"
                  :currency="formData.settlementCurrency"
                  @blur="onTaxChange(record)"
                />
                <PriceInput
                  v-else
                  :value="text"
                  :showTxt="true"
                  :currency="formData.settlementCurrency"
                />
              </template>

              <!-- 成本 -->
              <template slot="plannedCost" slot-scope="text, record">
                <PriceInput
                  v-if="!isDisabled"
                  :value.sync="record.plannedCost"
                  :currency="formData.settlementCurrency"
                  @blur="calcTotals"
                />
                <PriceInput
                  v-else
                  :value="text"
                  :showTxt="true"
                  :currency="formData.settlementCurrency"
                />
              </template>

              <!-- 计划开始日期 -->
              <template slot="planStartDate" slot-scope="text, record">
                <a-date-picker
                  v-if="!isDisabled"
                  v-model="record.planStartDate"
                  valueFormat="YYYY-MM-DD"
                  size="small"
                  style="width: 130px"
                />
                <span v-else>{{ text ? dayjs(text).format('YYYY-MM-DD') : '' }}</span>
              </template>

              <!-- 计划结束日期 -->
              <template slot="planEndDate" slot-scope="text, record">
                <a-date-picker
                  v-if="!isDisabled"
                  v-model="record.planEndDate"
                  valueFormat="YYYY-MM-DD"
                  size="small"
                  style="width: 130px"
                />
                <span v-else>{{ text ? dayjs(text).format('YYYY-MM-DD') : '' }}</span>
              </template>

              <!-- 付款到期日 -->
              <template slot="paymentDueDate" slot-scope="text, record">
                <a-date-picker
                  v-if="!isDisabled"
                  v-model="record.paymentDueDate"
                  valueFormat="YYYY-MM-DD"
                  size="small"
                  style="width: 130px"
                />
                <span v-else>{{ text ? dayjs(text).format('YYYY-MM-DD') : '' }}</span>
              </template>

              <!-- 项目类型 -->
              <template slot="projectType" slot-scope="text, record">
                <a-input v-if="!isDisabled" v-model="record.projectType" size="small" />
                <span v-else>{{ text }}</span>
              </template>

              <!-- 批次号 -->
              <template slot="productBatchNo" slot-scope="text, record">
                <a-input v-if="!isDisabled" v-model="record.productBatchNo" size="small" />
                <span v-else>{{ text }}</span>
              </template>

              <!-- 备注 -->
              <template slot="remark" slot-scope="text, record">
                <a-input
                  v-if="!isDisabled"
                  v-model="record.remark"
                  size="small"
                  :placeholder="$t('备注')"
                />
                <span v-else>{{ text }}</span>
              </template>

              <!-- 操作 -->
              <template slot="action" slot-scope="text, record, index">
                <a-button
                  type="link"
                  size="small"
                  style="color: #ff4d4f; padding: 0"
                  @click="handleDeleteDetail(index)"
                >
                  {{ $t('删除') }}
                </a-button>
              </template>
            </a-table>
          </ModalBox>

          <ModalBox id="AllocationInfo" :title="$t('分摊明细')" v-if="isDetail">
            <template v-slot:header>
              <div class="fz12 text-disabled">
                {{ $t('已选') }} {{ selectedAllocationKeys.length }} {{ $t('行') }}
              </div>
            </template>
            <CommonTable
              :columns="allocationColumns"
              :dataSource="allocationRows"
              :showSelect="true"
              :showPagination="false"
              :showSetting="false"
              :scroll="{ x: 2300 }"
              rowKey="id"
              :selected-row-keys.sync="selectedAllocationKeys"
            >
              <template v-slot:plannedAmount="{ text }">
                <PriceInput :value="text" :showTxt="true" :currency="formData.settlementCurrency" />
              </template>
              <template v-slot:plannedAmountWithoutTax="{ text }">
                <PriceInput :value="text" :showTxt="true" :currency="formData.settlementCurrency" />
              </template>
              <template v-slot:plannedTaxAmount="{ text }">
                <PriceInput :value="text" :showTxt="true" :currency="formData.settlementCurrency" />
              </template>
              <template v-slot:plannedCost="{ text }">
                <PriceInput :value="text" :showTxt="true" :currency="formData.settlementCurrency" />
              </template>
              <template v-slot:pushedAmount="{ text }">
                <PriceInput :value="text" :showTxt="true" :currency="formData.settlementCurrency" />
              </template>
              <template v-slot:pushedCost="{ text }">
                <PriceInput :value="text" :showTxt="true" :currency="formData.settlementCurrency" />
              </template>
              <template v-slot:confirmedAmount="{ text }">
                <PriceInput :value="text" :showTxt="true" :currency="formData.settlementCurrency" />
              </template>
              <template v-slot:confirmedCost="{ text }">
                <PriceInput :value="text" :showTxt="true" :currency="formData.settlementCurrency" />
              </template>
              <template v-slot:incomeCostConfirmOrderSnList="{ text }">
                <span v-if="text && text.length">
                  <a
                    v-for="(item, index) in text"
                    :key="index"
                    class="sn-link"
                    @click="viewConfirmDetail(item)"
                  >
                    {{ resolveConfirmSn(item) + (index < text.length - 1 ? ';' : '') }}
                  </a>
                </span>
              </template>
            </CommonTable>
          </ModalBox>
        </section>
        <OperationLog
          ref="OperationLogRef"
          :scrollHeight="scrollHeight"
          :actionSn="sn"
          :type="docType"
          v-if="isDetail"
        />
      </div>

      <BottomBtns
        :isEdit.sync="isEdit"
        :isDetail="isDetail"
        :draftLoading="draftLoading"
        :saveLoading="saveLoading"
        :status="formData.status"
        @submit="onSubmit"
        @cancel="getDetailInfo"
        @back="backForm"
      />
    </a-spin>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import http from '@/service/axios'
import api from '@/service/api'
import DatePicker from '@component/datePicker'
import BottomBtns from '@component/bottomBtns'
import OperationLog from '@component/operationLog'
import SelectCurrency from '@component/selectCurrency'
import SkuQuickQueryModal from '@component/skuQuickQueryModal'
import IncomePlanPushBtn from '@component/incomePlanPushBtn'
import { convertKeysToCamelCase, goBack, fetchDocumentMappings } from '@/common'
import debounce from '@/common/debounce'
import dayjs from 'dayjs'

// operateType 取值，与 operateDoc 的 action 保持一致
const OPERATE_TYPE = { SUBMIT: 'commit', CHECK: 'check', CANCEL: 'cancel' }
const BIZ_DOC_TYPE = 'IncomePlan'
const DATE_FIELDS = ['planStartDate', 'planEndDate', 'paymentDueDate']

export default {
  name: 'incomePlanDetail',
  components: {
    DatePicker,
    BottomBtns,
    OperationLog,
    SelectCurrency,
    SkuQuickQueryModal,
    IncomePlanPushBtn,
  },
  data() {
    return {
      id: undefined,
      sn: undefined,
      docType: BIZ_DOC_TYPE,
      operateType: OPERATE_TYPE,
      isDetail: false,
      isEdit: false,
      loading: false,
      draftLoading: false,
      saveLoading: false,
      currentGood: null,
      selectedAllocationKeys: [],
      formData: this.defaultFormData(),
      rules: {
        businessUnitCode: [
          { required: true, message: this.$t('请选择结算组织'), trigger: 'change' },
        ],
      },
      mappings: {
        bizDocType: {},
        planType: {},
        allocationMethod: {},
      },
    }
  },
  activated() {
    this.init()
    this.fetchMappings()
  },
  beforeRouteUpdate(to, from, next) {
    Object.assign(this.$data, this.$options.data.call(this))
    this.$nextTick(() => {
      this.init()
    })
    next()
  },
  computed: {
    ...mapState(['income_plan_allocation_method']),
    ...mapGetters([
      'incomePlanStatusMapping',
      'incomePlanDetailStatusMapping',
      'incomePlanAllocationMethodMapping',
      'incomePlanAllocationPushStatusMapping',
      'goodsTypeMapping',
    ]),
    isDisabled() {
      return this.isDetail && !this.isEdit
    },
    scrollHeight() {
      let height = window.innerHeight - 280
      return height * this.$store.state.rate + 'px'
    },
    planTypeList() {
      return this.income_plan_type || []
    },
    goodsTypeOptions() {
      const list = this.$store.state.goods_type || []
      return list.length
        ? list
        : [
            { code: 'FINISH_PRODUCT', name: this.$t('成品') },
            { code: 'RAW_MATERIAL', name: this.$t('原材料') },
          ]
    },
    detailColumns() {
      const cols = [
        {
          title: '#',
          width: 55,
          align: 'center',
          customRender: (text, record, index) => index + 1,
        },
        {
          title: this.$t('商品信息'),
          dataIndex: 'itemInfo',
          scopedSlots: { customRender: 'itemInfo' },
          width: 200,
        },
        {
          title: this.$t('商品类型'),
          dataIndex: 'itemType',
          scopedSlots: { customRender: 'itemType' },
          width: 130,
        },
        {
          title: this.$t('状态'),
          dataIndex: 'status',
          width: 110,
          customRender: (text) => this.incomePlanDetailStatusMapping[text] || text,
        },
        {
          title: this.$t('商品数量'),
          dataIndex: 'quantity',
          scopedSlots: { customRender: 'quantity' },
          width: 130,
        },
        {
          title: this.$t('含税金额'),
          dataIndex: 'plannedAmount',
          scopedSlots: { customRender: 'plannedAmount' },
          width: 140,
        },
        {
          title: this.$t('未税金额'),
          dataIndex: 'plannedAmountWithoutTax',
          scopedSlots: { customRender: 'plannedAmountWithoutTax' },
          width: 140,
        },
        {
          title: this.$t('税额'),
          dataIndex: 'plannedTaxAmount',
          scopedSlots: { customRender: 'plannedTaxAmount' },
          width: 130,
        },
        {
          title: this.$t('成本'),
          dataIndex: 'plannedCost',
          scopedSlots: { customRender: 'plannedCost' },
          width: 130,
        },
        {
          title: this.$t('计划开始日期'),
          dataIndex: 'planStartDate',
          scopedSlots: { customRender: 'planStartDate' },
          width: 150,
        },
        {
          title: this.$t('计划结束日期'),
          dataIndex: 'planEndDate',
          scopedSlots: { customRender: 'planEndDate' },
          width: 150,
        },
        {
          title: this.$t('付款到期日'),
          dataIndex: 'paymentDueDate',
          scopedSlots: { customRender: 'paymentDueDate' },
          width: 150,
        },
        {
          title: this.$t('结算时间'),
          dataIndex: 'paymentConfirmTime',
          width: 150,
        },
        {
          title: this.$t('项目类型'),
          dataIndex: 'projectType',
          scopedSlots: { customRender: 'projectType' },
          width: 140,
        },
        {
          title: this.$t('批次号'),
          dataIndex: 'productBatchNo',
          scopedSlots: { customRender: 'productBatchNo' },
          width: 140,
        },
        {
          title: this.$t('备注'),
          dataIndex: 'remark',
          scopedSlots: { customRender: 'remark' },
          width: 160,
        },
      ]
      if (!this.isDisabled) {
        cols.push({
          title: this.$t('操作'),
          scopedSlots: { customRender: 'action' },
          width: 70,
          align: 'center',
        })
      }
      return cols
    },
    allocationColumns() {
      return [
        {
          title: this.$t('商品名称'),
          dataIndex: 'itemName',
          width: 160,
        },
        // {
        //   title: this.$t('商品代码'),
        //   dataIndex: 'gtin',
        //   width: 140,
        // },
        {
          title: this.$t('会计期间'),
          dataIndex: 'accountingPeriod',
          width: 110,
        },
        {
          title: this.$t('关联确认单'),
          dataIndex: 'incomeCostConfirmOrderSnList',
          width: 220,
          scopedSlots: { customRender: 'incomeCostConfirmOrderSnList' },
        },
        {
          title: this.$t('分摊开始日期'),
          dataIndex: 'allocationStartDate',
          width: 130,
          customRender: (text) => (text ? dayjs(text).format('YYYY-MM-DD') : ''),
        },
        {
          title: this.$t('分摊结束日期'),
          dataIndex: 'allocationEndDate',
          width: 130,
          customRender: (text) => (text ? dayjs(text).format('YYYY-MM-DD') : ''),
        },
        {
          title: this.$t('分摊天数'),
          dataIndex: 'allocationDays',
          width: 100,
        },
        {
          title: this.$t('分摊比例') + '(%)',
          dataIndex: 'allocationRatio',
          width: 110,
        },
        {
          title: this.$t('含税金额'),
          dataIndex: 'plannedAmount',
          width: 130,
          scopedSlots: { customRender: 'plannedAmount' },
        },
        {
          title: this.$t('未税金额'),
          dataIndex: 'plannedAmountWithoutTax',
          width: 130,
          scopedSlots: { customRender: 'plannedAmountWithoutTax' },
        },
        {
          title: this.$t('税额'),
          dataIndex: 'plannedTaxAmount',
          width: 120,
          scopedSlots: { customRender: 'plannedTaxAmount' },
        },
        {
          title: this.$t('成本'),
          dataIndex: 'plannedCost',
          width: 120,
          scopedSlots: { customRender: 'plannedCost' },
        },
        {
          title: this.$t('已下推金额'),
          dataIndex: 'pushedAmount',
          width: 130,
          scopedSlots: { customRender: 'pushedAmount' },
        },
        {
          title: this.$t('已下推成本'),
          dataIndex: 'pushedCost',
          width: 130,
          scopedSlots: { customRender: 'pushedCost' },
        },
        {
          title: this.$t('已确认金额'),
          dataIndex: 'confirmedAmount',
          width: 130,
          scopedSlots: { customRender: 'confirmedAmount' },
        },
        {
          title: this.$t('已确认成本'),
          dataIndex: 'confirmedCost',
          width: 130,
          scopedSlots: { customRender: 'confirmedCost' },
        },
        {
          title: this.$t('下推状态'),
          dataIndex: 'pushStatus',
          width: 120,
          customRender: (text) => this.incomePlanAllocationPushStatusMapping[text] || text,
        },
        {
          title: this.$t('状态'),
          dataIndex: 'status',
          width: 110,
          customRender: (text) => this.incomePlanDetailStatusMapping[text] || text,
        },
        {
          title: this.$t('付款到期日'),
          dataIndex: 'paymentDueDate',
          width: 130,
          customRender: (text) => (text ? dayjs(text).format('YYYY-MM-DD') : ''),
        },
        {
          title: this.$t('备注'),
          dataIndex: 'remark',
          width: 160,
        },
      ]
    },
    allocationRows() {
      const rows = []
      ;(this.formData.detailList || []).forEach((detail) => {
        ;(detail.allocationList || []).forEach((allocation) => {
          rows.push({
            ...allocation,
            itemName: detail.itemName,
            gtin: detail.gtin,
          })
        })
      })
      return rows
    },
  },
  methods: {
    dayjs,
    resolveConfirmSn(item) {
      return typeof item === 'string' ? item : item?.sn || item?.orderSn || ''
    },
    viewConfirmDetail(item) {
      const sn = this.resolveConfirmSn(item)
      if (!sn) return
      window.open(
        `/receivableManage/incomeCostConfirmDetail?sn=${encodeURIComponent(sn)}`,
        '_blank'
      )
    },
    defaultFormData() {
      return {
        id: undefined,
        planSn: '',
        status: 'DRAFT',
        planType: undefined,
        allocationMethod: undefined,
        bizDocType: undefined,
        bizDocSn: '',
        businessUnitCode: undefined,
        businessUnitName: '',
        merchantCode: localStorage.getItem('merchantCode') || '',
        functionalCurrency: 'CNY',
        settlementCurrency: 'CNY',
        startDate: dayjs().format('YYYY-MM-DD'),
        endDate: dayjs().format('YYYY-MM-DD'),
        totalAmount: 0,
        totalAmountWithoutTax: 0,
        taxAmount: 0,
        totalCost: 0,
        confirmedAmount: 0,
        confirmedCost: 0,
        remark: '',
        detailList: [],
      }
    },
    init() {
      this.isEdit = false
      this.isDetail = false
      this.selectedAllocationKeys = []
      if (!this.$route.query.id) {
        // 创建模式
        this.id = undefined
        this.sn = undefined
        this.isEdit = true
        this.formData = this.defaultFormData()
        this.currentGood = null
      } else {
        this.id = this.$route.query.id
        this.sn = this.$route.query.sn
        this.isDetail = true
        this.getDetailInfo()
      }
    },
    changeTabs(value) {
      document.querySelector(`#${value}`).scrollIntoView(true)
    },
    async getDetailInfo() {
      if (!this.id) return
      this.loading = true
      try {
        const res = await http({
          url: api.getIncomePlanDetail,
          type: 'post',
          data: {
            id: this.id,
            planSn: this.sn,
          },
        })
        const result = convertKeysToCamelCase(res.result || {})
        result.detailList = (result.detailList || []).map((detail) => {
          const row = { ...detail, allocationList: detail.allocationList || [] }
          DATE_FIELDS.forEach((field) => {
            if (row[field]) row[field] = dayjs(row[field]).format('YYYY-MM-DD')
          })
          return row
        })
        this.formData = result
        this.selectedAllocationKeys = []
        this.$nextTick(() => {
          this.$refs.OperationLogRef && this.$refs.OperationLogRef.queryList()
        })
      } finally {
        this.loading = false
      }
    },
    backForm(back = 0) {
      goBack('incomePlanList', back)
    },
    handleChangeSku(data) {
      const itemStyle = Object.entries(data.selectedSpecs || {})
        .map(([, value]) => value)
        .join(';')
      const procurementUnitItem = data.unitList?.find((item) => item.procurementUnit) || {},
        baseUnitItem = data.unitList?.find((item) => item.baseUnit) || {}
      const rawUnit = procurementUnitItem.unitNameFull || baseUnitItem.unitNameFull || ''
      const baseUnit = baseUnitItem.unitNameFull || rawUnit || ''

      this.currentGood = {
        gtin: data.goodsCode,
        itemName: data.goodsName,
        itemStyle,
        itemType: data.goodsType === 'RAW_MATERIAL' ? 'RAW_MATERIAL' : 'FINISH_PRODUCT',
        rawUnit,
        baseUnit,
        quantity: 1,
        rawQuantity: 1,
      }
    },
    addGoodsToTable() {
      if (!this.currentGood || !this.currentGood.itemName) {
        return this.$message.warning(this.$t('请先选择商品'))
      }
      const newLine = {
        ...this.currentGood,
        sort: (this.formData.detailList || []).length + 1,
        planStartDate: this.formData.startDate
          ? dayjs(this.formData.startDate).format('YYYY-MM-DD')
          : dayjs().format('YYYY-MM-DD'),
        planEndDate: this.formData.endDate
          ? dayjs(this.formData.endDate).format('YYYY-MM-DD')
          : dayjs().format('YYYY-MM-DD'),
        paymentDueDate: '',
        projectType: '',
        productBatchNo: '',
        plannedAmount: 0,
        plannedAmountWithoutTax: 0,
        plannedTaxAmount: 0,
        plannedCost: 0,
        remark: '',
        allocationList: [],
      }
      if (!this.formData.detailList) {
        this.$set(this.formData, 'detailList', [])
      }
      this.formData.detailList.push(newLine)
      this.calcTotals()
      this.$message.success(this.$t('添加成功'))
    },
    handleAddBlankLine() {
      const newLine = {
        sort: (this.formData.detailList || []).length + 1,
        itemName: '',
        gtin: '',
        itemStyle: '',
        itemType: '',
        baseUnit: '',
        rawUnit: '',
        quantity: 1,
        rawQuantity: 1,
        planStartDate: this.formData.startDate
          ? dayjs(this.formData.startDate).format('YYYY-MM-DD')
          : dayjs().format('YYYY-MM-DD'),
        planEndDate: this.formData.endDate
          ? dayjs(this.formData.endDate).format('YYYY-MM-DD')
          : dayjs().format('YYYY-MM-DD'),
        paymentDueDate: '',
        projectType: '',
        productBatchNo: '',
        plannedAmount: 0,
        plannedAmountWithoutTax: 0,
        plannedTaxAmount: 0,
        plannedCost: 0,
        remark: '',
        allocationList: [],
      }
      if (!this.formData.detailList) {
        this.$set(this.formData, 'detailList', [])
      }
      this.formData.detailList.push(newLine)
      this.calcTotals()
    },
    handleDeleteDetail(index) {
      this.formData.detailList.splice(index, 1)
      this.calcTotals()
    },
    // 含税金额 / 未税金额变化：税额 = 含税 - 未税
    onAmountChange(record) {
      const amount = Number(record.plannedAmount) || 0
      const withoutTax = Number(record.plannedAmountWithoutTax) || 0
      record.plannedTaxAmount = Number((amount - withoutTax).toFixed(2))
      this.calcTotals()
    },
    onWithoutTaxChange(record) {
      const amount = Number(record.plannedAmount) || 0
      const withoutTax = Number(record.plannedAmountWithoutTax) || 0
      record.plannedTaxAmount = Number((amount - withoutTax).toFixed(2))
      this.calcTotals()
    },
    // 税额变化：未税 = 含税 - 税额
    onTaxChange(record) {
      const amount = Number(record.plannedAmount) || 0
      const tax = Number(record.plannedTaxAmount) || 0
      record.plannedAmountWithoutTax = Number((amount - tax).toFixed(2))
      this.calcTotals()
    },
    calcTotals() {
      const list = this.formData.detailList || []
      let amount = 0,
        withoutTax = 0,
        tax = 0,
        cost = 0
      list.forEach((row) => {
        amount += Number(row.plannedAmount) || 0
        withoutTax += Number(row.plannedAmountWithoutTax) || 0
        tax += Number(row.plannedTaxAmount) || 0
        cost += Number(row.plannedCost) || 0
      })
      this.formData.totalAmount = Number(amount.toFixed(2))
      this.formData.totalAmountWithoutTax = Number(withoutTax.toFixed(2))
      this.formData.taxAmount = Number(tax.toFixed(2))
      this.formData.totalCost = Number(cost.toFixed(2))
    },
    buildPayload() {
      const detailList = (this.formData.detailList || []).map((row, idx) => ({
        id: row.id,
        bizDocDetailSn: row.bizDocDetailSn || '',
        accountingPeriod: row.accountingPeriod || '',
        gtin: row.gtin || '',
        itemName: row.itemName || '',
        itemStyle: row.itemStyle || '',
        itemType: row.itemType || '',
        baseUnit: row.baseUnit || '',
        rawUnit: row.rawUnit || '',
        quantity: Number(row.quantity) || 0,
        rawQuantity: Number(row.rawQuantity || row.quantity) || 0,
        projectType: row.projectType || '',
        productBatchNo: row.productBatchNo || '',
        planStartDate: row.planStartDate || '',
        planEndDate: row.planEndDate || '',
        paymentDueDate: row.paymentDueDate || '',
        plannedAmount: Number(row.plannedAmount) || 0,
        plannedAmountWithoutTax: Number(row.plannedAmountWithoutTax) || 0,
        plannedTaxAmount: Number(row.plannedTaxAmount) || 0,
        plannedCost: Number(row.plannedCost) || 0,
        remark: row.remark || '',
        sort: idx + 1,
      }))
      return {
        incomePlan: {
          id: this.formData.id,
          planSn: this.formData.planSn || '',
          planType: this.formData.planType || '',
          allocationMethod: this.formData.allocationMethod || '',
          bizDocType: this.formData.bizDocType || '',
          bizDocSn: this.formData.bizDocSn || '',
          businessUnitCode: this.formData.businessUnitCode || '',
          businessUnitName: this.formData.businessUnitName || '',
          merchantCode: this.formData.merchantCode || localStorage.getItem('merchantCode') || '',
          functionalCurrency: this.formData.functionalCurrency || 'CNY',
          settlementCurrency: this.formData.settlementCurrency || 'CNY',
          startDate: this.formData.startDate || '',
          endDate: this.formData.endDate || '',
          remark: this.formData.remark || '',
          detailList,
        },
      }
    },
    onSubmit: debounce(async function (status) {
      if (this.saveLoading || this.draftLoading) return

      let valid = false
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.validate((v) => {
          valid = v
        })
      }
      if (!valid) return

      if (!this.formData.detailList || this.formData.detailList.length === 0) {
        return this.$message.warning(this.$t('请至少添加一条明细'))
      }
      for (let i = 0; i < this.formData.detailList.length; i++) {
        const item = this.formData.detailList[i]
        if (!item.itemName || !item.itemName.trim()) {
          return this.$message.warning(
            `${this.$t('第')} ${i + 1} ${this.$t('行明细请输入商品名称')}`
          )
        }
      }

      const isDraft = status === 'DRAFT'
      isDraft ? (this.draftLoading = true) : (this.saveLoading = true)
      // 编辑待审核的单据时，仅保存不重复提交
      const needSubmit = status === 'WAIT_CHECK' && (!this.id || this.formData.status === 'DRAFT')
      try {
        const res = await http({
          url: api.createOrUpdateIncomePlan,
          type: 'post',
          data: this.buildPayload(),
        })
        const newId = res?.result?.id
        if (needSubmit && newId) {
          await http({
            url: api.operateIncomePlan,
            type: 'post',
            data: { id: newId, operateType: OPERATE_TYPE.SUBMIT },
          })
        }
        this.$message.success(isDraft ? this.$t('暂存成功') : this.$t('提交成功'))
        this.backForm()
      } finally {
        this.draftLoading = false
        this.saveLoading = false
      }
    }),
    async fetchMappings() {
      this.mappings = await fetchDocumentMappings(this.docType, [
        'bizDocType',
        'planType',
        'allocationMethod',
      ])
    },
  },
}
</script>

<style lang="scss" scoped>
.content-overflow {
  width: 100%;
  overflow: auto;
  display: flex;
}
.left-div {
  flex: 1;
}
.fixContent {
  padding-top: 0;
  overflow-y: auto;
  overflow-x: hidden;
  padding-bottom: 0;
}
.sn-link {
  color: #1890ff;
  cursor: pointer;
  &:hover {
    color: #40a9ff;
    text-decoration: underline;
  }
}
</style>
